export const environment = {
  env: 'PROD',
  cookieDomain: 'maplix.com',
  production: true,
  apps: {
    root: 'https://app.maplix.com/map/',
    auth: 'https://app.maplix.com/account/',
    home: 'https://app.maplix.com/dashboard/',
    editor: 'https://app.maplix.com/editor/',
    surveyViewer: 'https://app.maplix.com/survey/',
    mapViewer: 'https://app.maplix.com/map/',
    mapShortcut: 'https://map.maplix.com/',
  },
  api: `https://api.maplix.com/`,
  stitchId: 'maplix-account-prod-ukpqz',
  geoserver: 'https://geo.maplix.com/geoserver/',
  geoserverDb: 'maplix-prod',
  mapboxToken: 'pk.eyJ1IjoiY2VkcmljdmVyc2x1eXMiLCJhIjoiY2s5azFwaTFvMDg5czNsbnNxY2ExbHgyeSJ9.W_Tk-JA9ujNEL55b_cf7Hw',
  plausible: {
    domain: 'maplix.com',
  },
};
